import { render } from "./PostLikeButton.vue?vue&type=template&id=2654fb01&scoped=true"
import script from "./PostLikeButton.vue?vue&type=script&lang=js"
export * from "./PostLikeButton.vue?vue&type=script&lang=js"

import "./post-like-button.scss?vue&type=style&index=0&id=2654fb01&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2654fb01"]])

export default __exports__